import Icon from "@components/Icon";
import { ReactNode } from "react";
import styles from "./Chip.module.css";

type ChipProps = {
  children: ReactNode;
  className?: string;
  icon: string;
};

function Chip({ children, className, icon }: ChipProps) {
  return (
    <span className={`${styles.chip}${className ? ` ${className}` : ""}`}>
      <Icon name={icon} size="0.875rem" className={styles.icon} />
      {children}
    </span>
  );
}

export default Chip;
